/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Choose_FilesInputs */

const en_dialog_choose_files = /** @type {(inputs: Dialog_Choose_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or choose files`)
};

const es_dialog_choose_files = /** @type {(inputs: Dialog_Choose_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o elige archivos`)
};

/**
* | output |
* | --- |
* | "or choose files" |
*
* @param {Dialog_Choose_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_choose_files = /** @type {((inputs?: Dialog_Choose_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Choose_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_choose_files(inputs)
	return en_dialog_choose_files(inputs)
});